(function () {
  'use strict';

  const discoveryTags = ['workwear', 'ffc-personalisation', 'ffc-dtf', 'ffc-embroidery'];

  function rangeUrl(target, current) {
    const result = new URL(target, current);
    result.search = new URL(current).search;
    result.searchParams.delete('page');
    result.searchParams.delete('section_id');
    // The route tag is an AND constraint; native tag values otherwise use OR.
    const tags = result.searchParams.getAll('filter.p.tag').filter(tag => !discoveryTags.includes(tag));
    result.searchParams.delete('filter.p.tag');
    tags.forEach(tag => result.searchParams.append('filter.p.tag', tag));
    return result.toString();
  }

  function sourceFilterUrl(collectionUrl, tags, oldTag, newTag, current) {
    const next = tags.filter(tag => tag !== oldTag);
    if (newTag && !next.includes(newTag)) next.push(newTag);
    const path = collectionUrl + (next.length ? '/' + next.map(encodeURIComponent).join('+') : '');
    return rangeUrl(path, current);
  }

  function discoveryMethodUrl(collectionUrl, tags, method, current) {
    const next = tags.filter(tag => !['ffc-personalisation', 'ffc-dtf', 'ffc-embroidery'].includes(tag));
    if (method || !tags.includes('workwear')) next.push('ffc-personalisation');
    if (method === 'dtf' || method === 'embroidery') next.push('ffc-' + method);
    return rangeUrl(collectionUrl + '/' + next.map(encodeURIComponent).join('+'), current);
  }

  function fabricGroupLabel(label) {
    const text = String(label || '').trim();
    const normalised = text.toLocaleLowerCase('en-GB');
    const cotton = normalised.includes('cotton');
    const polyester = normalised.includes('polyester');
    if (cotton && polyester) return 'Cotton / Polyester mix';
    if (cotton) return 'Cotton';
    if (polyester) return 'Polyester';
    if (normalised.includes('acrylic')) return 'Acrylic';
    if (normalised.includes('wool')) return 'Wool';
    if (normalised.includes('nylon') || normalised.includes('polyamide')) return 'Nylon / Polyamide';
    if (normalised.includes('leather') || normalised.includes('nubuck')) return 'Leather';
    if (normalised.includes('polyurethane') || /\btpu\b|\bpu\b/.test(normalised)) return 'Polyurethane / PU';
    if (normalised.includes('soft shell')) return 'Soft shell';
    return 'Other materials';
  }

  function simplifyFabricFacet(form) {
    if (!form || form.dataset.ffcFabricReady) return;
    const values = form.querySelector('[data-ffc-fabric-values]');
    if (!values) return;
    const sources = [...values.querySelectorAll('[data-ffc-fabric-source]')];
    if (!sources.length) return;
    form.dataset.ffcFabricReady = 'true';

    const groups = new Map();
    sources.forEach(source => {
      const input = source.querySelector('input[type="checkbox"]');
      if (!input) return;
      const label = fabricGroupLabel(input.dataset.ffcFabricLabel || input.value);
      if (!groups.has(label)) groups.set(label, { label, count: 0, inputs: [] });
      const group = groups.get(label);
      group.count += Number(input.dataset.ffcFabricCount || 0);
      group.inputs.push(input);
    });

    const preferred = ['Cotton', 'Cotton / Polyester mix', 'Polyester', 'Soft shell',
      'Acrylic', 'Wool', 'Nylon / Polyamide', 'Leather', 'Polyurethane / PU', 'Other materials'];
    const ordered = [...groups.values()].sort((a, b) => {
      const ai = preferred.indexOf(a.label);
      const bi = preferred.indexOf(b.label);
      if (ai !== -1 || bi !== -1) return (ai === -1 ? preferred.length : ai) - (bi === -1 ? preferred.length : bi);
      return a.label.localeCompare(b.label, 'en-GB');
    });

    const fragment = form.ownerDocument.createDocumentFragment();
    ordered.forEach((group, index) => {
      const label = form.ownerDocument.createElement('label');
      const checkbox = form.ownerDocument.createElement('input');
      const caption = form.ownerDocument.createElement('span');
      checkbox.type = 'checkbox';
      checkbox.id = `${group.inputs[0].id}-group-${index + 1}`;
      checkbox.dataset.ffcFabricGroup = group.label;
      checkbox.disabled = group.inputs.every(input => input.disabled);
      checkbox.checked = group.inputs.some(input => input.checked);
      if (checkbox.checked) group.inputs.forEach(input => { if (!input.disabled) input.checked = true; });
      caption.textContent = `${group.label} (${group.count})`;
      label.htmlFor = checkbox.id;
      label.dataset.ffcFabricGroupOption = '';
      label.append(checkbox, caption);
      checkbox.addEventListener('change', () => {
        group.inputs.forEach(input => { if (!input.disabled) input.checked = checkbox.checked; });
      });
      fragment.append(label);
    });
    sources.forEach(source => { source.hidden = true; });
    values.append(fragment);
  }

  function autoApplyForm(form) {
    if (form.dataset.ffcAutoApply || typeof form.requestSubmit !== 'function') return;
    form.addEventListener('change', event => {
      if (!event.target.matches('select, input[type="checkbox"], input[type="radio"], input[type="number"]') || event.target.disabled) return;
      form.requestSubmit();
    });
    form.dataset.ffcAutoApply = 'true';
    form.querySelectorAll('button[type="submit"]').forEach(button => { button.hidden = true; });
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = {
    rangeUrl, sourceFilterUrl, discoveryMethodUrl, fabricGroupLabel, simplifyFabricFacet, autoApplyForm
  };
  if (typeof document === 'undefined') return;

  document.addEventListener('change', event => {
    const rangeSelect = event.target.closest('[data-ffc-discovery-range]');
    if (rangeSelect) {
      window.location.assign(rangeUrl(rangeSelect.value, window.location.href));
      return;
    }
    const methodSelect = event.target.closest('[data-ffc-discovery-method]');
    if (methodSelect) {
      const tags = JSON.parse(methodSelect.dataset.currentTags || '[]') || [];
      window.location.assign(discoveryMethodUrl(methodSelect.dataset.collectionUrl, tags,
        methodSelect.value, window.location.href));
      return;
    }
    const select = event.target.closest('[data-ffc-source-filter]');
    if (!select) return;
    const tags = JSON.parse(select.dataset.currentTags || '[]') || [];
    window.location.assign(sourceFilterUrl(select.dataset.collectionUrl, tags,
      select.dataset.selectedTag, select.value, window.location.href));
  });

  function initialise(root) {
    root.querySelectorAll('[data-ffc-fabric-facet]').forEach(simplifyFabricFacet);
    root.querySelectorAll('form.ffc-ux-facet, form.ffc-ux-sort').forEach(autoApplyForm);
    root.querySelectorAll('[data-ffc-workwear-switch]').forEach(toggle => {
      toggle.querySelectorAll('a').forEach(link => {
        link.setAttribute('aria-current', link.parentElement.classList.contains('is-selected') ? 'page' : 'false');
        if (link.dataset.ffcRangeReady) return;
        link.dataset.ffcRangeReady = 'true';
        const target = link.href;
        link.href = rangeUrl(target, window.location.href);
        const update = () => { link.href = rangeUrl(target, window.location.href); };
        link.addEventListener('click', update);
        link.addEventListener('auxclick', update);
        link.addEventListener('focus', update);
      });
    });
    root.querySelectorAll('[data-ffc-brand-search]').forEach(input => {
      if (input.dataset.ffcSearchReady) return;
      input.dataset.ffcSearchReady = 'true';
      const directory = input.closest('[data-ffc-brand-directory]');
      const entries = [...directory.querySelectorAll('[data-ffc-catalogue-entry]')];
      const empty = directory.querySelector('[data-ffc-brand-empty]');
      const count = directory.querySelector('[data-ffc-brand-count]');
      const update = () => {
        const term = input.value.trim().toLocaleLowerCase('en-GB');
        let shown = 0;
        entries.forEach(entry => {
          entry.hidden = !entry.textContent.toLocaleLowerCase('en-GB').includes(term);
          if (!entry.hidden) shown += 1;
        });
        empty.hidden = shown > 0;
        count.textContent = shown + (shown === 1 ? ' brand' : ' brands');
      };
      input.addEventListener('input', update);
      update();
    });
  }

  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
}());
